import React, { PropsWithChildren } from "react";

import { Grid } from "@mui/material";

import useStyles from "./styles";

interface DespatchSectionTitleProps {}

export const DespatchSectionTitle = ({
  children,
}: PropsWithChildren<DespatchSectionTitleProps>) => {
  const classes = useStyles();

  return (
    <Grid item xs={12}>
      <span className={classes.title}> {children}</span>
    </Grid>
  );
};
